import { useMutation, useQueryClient } from "@tanstack/react-query";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateSellerCoupons } from "@/lib/query/core/invalidation";

type DeleteCouponInput = {
  storeSlug: string;
  couponId: string;
};

export function useDeleteCouponMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: ({ couponId }: DeleteCouponInput) =>
      apiJsonClient<unknown>(endpoints.seller.couponById(couponId), {
        method: "DELETE",
      }),
    onSuccess: async (_data, variables) => {
      await invalidateSellerCoupons(queryClient, variables.storeSlug);
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
